import React from 'react'
import {applyMiddleware, compose, createStore} from 'redux'
import {routerMiddleware} from 'react-router-redux'
import {composeWithDevTools} from 'redux-devtools-extension'
import {createBrowserHistory} from 'history'
import thunk from 'redux-thunk'
import reducer from 'ducks'
import preprocessor from 'ducks/preprocessor'
import analytics from 'ducks/analytics'

export const history = createBrowserHistory()

const router = routerMiddleware(history)
const middlewares = [router, thunk, preprocessor, analytics]

const isLogger = false
if (isLogger && process.env.NODE_ENV === 'development') {
  const { logger } = require('redux-logger')
  middlewares.push(logger)
}

const composeWrapper = process.env.NODE_ENV === 'development' ? composeWithDevTools : compose
const storeEnhancer = composeWrapper(applyMiddleware(...middlewares))

export const store = createStore(reducer, storeEnhancer)


// WEBPACK FOOTER //
// ./src/store.js